import * as React from "react";
import {
  FArticleSmallInterface,
  FDocligneBeforeLivraisonInterface,
} from "../../../interfaces/FArticleInterface";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import { Card, CardContent, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import SecurityIcon from "@mui/icons-material/Security";

interface State {
  fArticle: FArticleSmallInterface | undefined;
}

export const FDoclignesBeforeLivraisonFArticleComponent = React.memo(
  React.forwardRef(({ fArticle }: State, ref) => {
    const { t, i18n } = useTranslation();
    const isAdmin = useAppSelector(
      (state: RootState) => state.globalState.isAdmin
    );
    const getFDoclignesBeforeLivraison = React.useCallback(() => {
      if (!fArticle?.fDoclignesBeforeLivraison) {
        return fArticle?.fDoclignesBeforeLivraison;
      }
      let r: FDocligneBeforeLivraisonInterface[] = [
        ...fArticle.fDoclignesBeforeLivraison,
      ];
      if (r.length > 1) {
        r = Object.values(
          r.reduce((acc: any, item) => {
            if (!acc[item.fDocentete.doPiece]) {
              acc[item.fDocentete.doPiece] = { ...item };
            } else {
              acc[item.fDocentete.doPiece].dlQte =
                Number(acc[item.fDocentete.doPiece].dlQte) + Number(item.dlQte);
            }
            return acc;
          }, {})
        );
      }
      r.sort((a, b) => {
        if (a.doType !== b.doType) {
          return a.doType - b.doType;
        }
        return new Date(a.doDate).getTime() - new Date(b.doDate).getTime();
      });
      return r;
    }, [fArticle?.fDoclignesBeforeLivraison]);
    const [fDoclignesBeforeLivraison, setFDoclignesBeforeLivraison] =
      React.useState<FDocligneBeforeLivraisonInterface[] | undefined>(
        getFDoclignesBeforeLivraison()
      );

    React.useEffect(() => {
      setFDoclignesBeforeLivraison(getFDoclignesBeforeLivraison());
    }, [fArticle?.fDoclignesBeforeLivraison]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {fDoclignesBeforeLivraison && isAdmin && (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  {fDoclignesBeforeLivraison.map(
                    (fDocligne, indexFDocligne) => (
                      <TableCell
                        sx={{
                          padding: 0,
                          ...(indexFDocligne > 0 && {
                            paddingLeft: 0.5,
                          }),
                        }}
                        key={indexFDocligne}
                      >
                        <Card
                          variant="outlined"
                          sx={{
                            backgroundColor: "rgba(211, 47, 47,0.5)",
                            ...(fDocligne.doType < 10 && {
                              backgroundColor: "rgba(92, 184, 92,0.5)",
                            }),
                          }}
                        >
                          <CardContent
                            sx={{
                              padding: 0,
                              paddingX: 0.5,
                              paddingBottom: "0 !important",
                              display: "flex",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                            }}
                          >
                            <ul
                              style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              <li>
                                {t(
                                  "word.fdocentete.doType." + fDocligne.doType
                                )}
                              </li>
                              <li>{fDocligne.ctNum} {fDocligne.ctIntitule}</li>
                              <li>{fDocligne.fDocentete.doPiece}</li>
                              <li>
                                <Tooltip title={t("word.quantity")}>
                                  <Typography component="span">
                                    {Number(fDocligne.dlQte)}
                                  </Typography>
                                </Tooltip>
                              </li>
                              <li>
                                {new Date(fDocligne.doDate).toLocaleString(
                                  i18n.language,
                                  {
                                    dateStyle: "short",
                                    timeZone: "Etc/UTC",
                                  }
                                )}
                              </li>
                            </ul>
                            {fDocligne.fiable && (
                              <Tooltip title={t("word.fiable")}>
                                <SecurityIcon
                                  fontSize="large"
                                  color="primary"
                                />
                              </Tooltip>
                            )}
                          </CardContent>
                        </Card>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </>
    );
  })
);
